export const headCells = [
  {
    id: "Job_id",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "PO #",
    width: 140,
  },
  {
    id: "CustomerName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Customer Name",
    width: 180,
  },
  {
    id: "CategoryName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Category",
    width: 150,
  },
  {
    id: "Name",
    numeric: false,
    disablePadding: false,
    label: "Job Name",
    width: 120,
  },
  {
    id: "OrderAmount",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Order Amount",
    width: 130,
  },
  {
    id: "EmployeeName",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Employee Name",
    width: 200,
  },
  {
    id: "SupplierName",
    numeric: false,
    disablePadding: false,
    label: "Supplier Name",
    width: 150,
  },
  {
    id: "Status",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Status",
    width: 100,
  },
  {
    id: "CreatedAt",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Created Date",
    width: 150,
  },
  {
    id: "Actions",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "Actions",
    width: 100,
  },
];

export const rowsPerPageOptions = [10, 25, 50, 100];
